module.exports = __webpack_public_path__ + "img/Group 1000000928.7dbf8800.svg";